import React from "react";
import { navLinks } from "../../mock";
import { Button } from "../ui/button";

export default function DesktopNav() {
  return (
    <>
      <nav className="hidden lg:flex items-center gap-8">
        {navLinks.map((l) => (
          <a
            key={l.href}
            href={l.href}
            className="text-sm font-medium text-gray-700 hover:text-brand relative group"
          >
            {l.label}
            <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-brand group-hover:w-full transition-all duration-300" />
          </a>
        ))}
      </nav>

      <div className="hidden lg:block">
        <Button asChild className="bg-brand hover:bg-brand-dark text-white rounded-full px-6 h-11">
          <a href="#contact">Get In Touch</a>
        </Button>
      </div>
    </>
  );
}
